import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { MemberService } from "../../services/jrni/member.service";
import { DepartmentService } from "../../services/jrni/department.service";
import { Router } from "@angular/router";
import { AlertService } from "../../_alert";
import { ServicesService } from "../../services/jrni/services.service";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { DatastoreService } from "../../services/datastore.service";
import { AvailabilityService } from "../../services/jrni/availability.service";
import { QuestionsService } from "../../services/questions.service";
import { ConfigService } from "../../services/config.service";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import * as he from 'he';
import moment from "moment";
import { ApiService } from "../../services/jrni/api.service";
import { AppConfig } from "../../app.config";
import { inject } from "@angular/core";

@Component({
  selector: "app-services",
  templateUrl: "./services.component.html",
  styleUrls: ["./services.component.scss"],
})
export class ServicesComponent implements OnInit {
  private core = AppConfig.settings.core;
  selectedDepartment;
  pageTitle;
  servicePageText;
  servicesList;
  filteredServiceList: any;
  selectedService;
  companyQuestions = [];
  suggestions: any;
  location;
  guidanceText;
  submitted: boolean = false;
  invalidInitForm: any;
  showServices = false;
  answeredQuestions = [false, false, false];
  config: any;
  showContinueButton = false;
  loadedConfig: boolean = false;
  // move to config soon
  ceramony_options = [{ option: "Yes" }, { option: "No" }];
  ageType = "";
  compQuestions = [];
  addresses: any;
  showingAddresses: boolean;
  companyId: any;
  debounceTimer: any;
  skipLocations: any;
  locations: any;
  selectedLocation: any;
  autoSetLocation: boolean = false;
  searchText = '';
  setCompanyFromQuestion: any;
  adminOnlyJourney: any;
  showOther: any;
  lookupError: any;

  serviceUnavailable: boolean;

  formBuilder: UntypedFormBuilder = inject(UntypedFormBuilder);
  datastoreService: DatastoreService = inject(DatastoreService);
  constructor(
    private departmentService: DepartmentService,
    private router: Router,
    protected alertService: AlertService,
    private servicesService: ServicesService,
    private cdref: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private memberService: MemberService,
    private availabilityService: AvailabilityService,
    private questionsService: QuestionsService,
    public translateService: TranslateService,
    public configService: ConfigService,
    private apiService: ApiService
  ) { }

  companyQuestionsForm: UntypedFormGroup = this.formBuilder.group({});

  initQuestions: UntypedFormGroup = new UntypedFormGroup({
    ceramony_two_years: new UntypedFormControl('', Validators.required),
    type_of_ceramony: new UntypedFormControl('', Validators.required)
  });

  get form() {
    return this.companyQuestionsForm.controls;
  }

  validateCeramonyQuestion() {
    this.invalidInitForm = undefined;
    if (this.initQuestions.get('ceramony_two_years').value == "Yes") {
      this.invalidInitForm = "over_two_years";
    }
  }

  validateCeramonyTypeQuestion() {
    this.invalidInitForm = undefined;
    if (this.initQuestions.get('type_of_ceramony').value) {
      if (this.initQuestions.get('type_of_ceramony').value == "other") {
        this.showOther = true;
      } else {
        this.showOther = false;
        this.datastoreService.type_of_ceramony = this.initQuestions.get('type_of_ceramony').value
        this.companyQuestions = []; // reset if changing answer
        this.questionsService.getCompanyInitQuestions(this.initQuestions.get('type_of_ceramony').value).subscribe((res: any) => {
          this.datastoreService.companyQuestions = res.questions
          this.addQuestionsToForm(res.questions)
        });
      }
    }
  }

  // Number input text validation, keycode 8 is backspace
  keyPressNumberField(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  // validate future dates
  futureDateValidator(control) {
    const currentDate = new Date();
    const inputDate = new Date(control.value);
    if (control.value) {
      if (inputDate > currentDate) {
        return { futureDate: true };
      }
      return null;
    } else {
      return null;
    }

  }

  // validate past dates
  pastDateValidator(control) {
    const currentDate = new Date();
    const inputDate = new Date(control.value);
    if (control.value) {
      if (inputDate < currentDate) {
        return { pastDate: true };
      }
      return null;
    } else {
      return null;
    }
  }

  // the "SCHEMA"
  onQuestionChange() {
    this.showServices = false;
    this.datastoreService.extraDuration = 0; // reset or we add more on everytime
    const bookingQuestions = this.companyQuestions;
    // Conditional questions logic
    // for (let index = 0; index < bookingQuestions.length; index++) {
    bookingQuestions.forEach(async (bookingQuestion: any) => {
      bookingQuestion.visible = false; // reset any questions that shouldnt be visible
      // go get the answer for every question from the form
      let control = this.companyQuestionsForm.get(`${bookingQuestion.id}`);
      bookingQuestion.answer = undefined;
      if (control) {
        // set booking question from form values
        bookingQuestion.answer = control.value ? control.value : undefined;
      }

      if (bookingQuestion["help_text"]) {
        bookingQuestion.conditionals = JSON.parse(bookingQuestion["help_text"]); // to change to settings block soon...
        if (bookingQuestion.conditionals.hasOwnProperty('help_text')) {
          bookingQuestion.helptext = bookingQuestion.conditionals.help_text;
          let linkPattern = /#(.*?)#/g;
          if (linkPattern.test(bookingQuestion.helptext)) {
            bookingQuestion.helptext = bookingQuestion.helptext.replace(linkPattern, function (match, p1) {
              return `<a href="${bookingQuestion.conditionals.hyperlink}" target="_blank">` + p1 + '</a>';
            });
          }
        }
        // these should be dynamic if need to add more to just add EVERY conditional to the bookingQuestion object
        if (bookingQuestion.conditionals.hasOwnProperty('question-font-colour')) {
          bookingQuestion.customLabelColour = bookingQuestion.conditionals['question-font-colour'];
        }
        if (bookingQuestion.conditionals.hasOwnProperty('filter_by')) {
          bookingQuestion.filter_by = bookingQuestion.conditionals['filter_by'];
        }
        if (bookingQuestion.conditionals.hasOwnProperty('filter_by_name')) {
          bookingQuestion.filter_by_name = bookingQuestion.conditionals['filter_by_name'];
        }

        if (bookingQuestion.conditionals.hasOwnProperty('lookup')) {
          bookingQuestion.aws_lookup = true;
          bookingQuestion.aws_table = bookingQuestion.conditionals['lookup'].aws_table;
          bookingQuestion.field = bookingQuestion.conditionals['lookup'].field;
          bookingQuestion.lookup_field = bookingQuestion.conditionals['lookup'].question_id;
        }

        if (bookingQuestion.conditionals.hasOwnProperty('question_reference')) {
          bookingQuestion.question_reference =
            bookingQuestion.conditionals['question_reference'];
        }

        // specific conditions
        if (bookingQuestion.conditionals.hasOwnProperty('address_lookup')) {
          if (bookingQuestion.conditionals['address_lookup'] === 'yes' || bookingQuestion.conditionals['address_lookup'] === 'true') {
            bookingQuestion.address_lookup = true
          }
        }
        if (bookingQuestion.conditionals.hasOwnProperty('resource_lookup')) {
          if (bookingQuestion.conditionals['resource_lookup'] === 'yes' || bookingQuestion.conditionals['resource_lookup'] === 'true') {
            bookingQuestion.resource_lookup = true;
            bookingQuestion.selected_resource = undefined;
          }
        }
        if (bookingQuestion.conditionals.hasOwnProperty('company_and_resource_set')) {
          if (bookingQuestion.conditionals['company_and_resource_set'] === 'yes' || bookingQuestion.conditionals['company_and_resource_set'] === 'true') {
            bookingQuestion.company_and_resource_set = true;
            this.autoSetLocation = true;
          }
        }

        if (bookingQuestion.conditionals.hasOwnProperty('validation')) {
          if (!this.config.validation) {
            // if there is no validation on the root
            // its probably under the journey_config
            this.config.validation =
              this.config.journey_config?.appointments?.validation;
          }
          if (this.config.validation[bookingQuestion.conditionals.validation]) {
            bookingQuestion.validation = this.config.validation[bookingQuestion.conditionals.validation];
            bookingQuestion.validation_message = bookingQuestion.conditionals.validation_message;
            let validators = [Validators.pattern(bookingQuestion.validation)];
            if (bookingQuestion.required) {
              validators.push(Validators.required);
            }
            control.setValidators(validators);
            this.companyQuestionsForm.updateValueAndValidity();
          }
          else {
            console.log(bookingQuestion.conditionals.validation);
            if (bookingQuestion.conditionals.validation == 'email') {
              bookingQuestion.validation = 'email';
              bookingQuestion.validation_message = bookingQuestion.conditionals.validation_message;
              let validators = [Validators.email];
              if (bookingQuestion.required) {
                validators.push(Validators.required);
              }
              control.setValidators(validators);
              this.companyQuestionsForm.updateValueAndValidity();
            }
          }
        } else {
          if (bookingQuestion.required) {
            control.setValidators(Validators.required);
          }
        }

        if (bookingQuestion.conditionals.hasOwnProperty('section_title')) {
          if (bookingQuestion.conditionals.section_title) {
            bookingQuestion.detail_type = "heading_2";
          }
        }

        if (bookingQuestion.detail_type === 'date') {
          bookingQuestion.hide_dates_in_future = false;
          bookingQuestion.hide_dates_in_past = false;

          if (bookingQuestion.conditionals.hasOwnProperty('hide_dates_in_future') && bookingQuestion.conditionals.hide_dates_in_future) {
            bookingQuestion.hide_dates_in_future = moment().format('YYYY-MM-DD');
            // future date
            if (bookingQuestion.hide_dates_in_future) {
              let validators = [];
              if (bookingQuestion.required) {
                validators.push(Validators.required);
              }
              validators.push(this.futureDateValidator);
              control.setValidators(validators);
              control.updateValueAndValidity();
              this.companyQuestionsForm.updateValueAndValidity();
            }
          }

          if (bookingQuestion.conditionals.hasOwnProperty('hide_dates_in_past') && bookingQuestion.conditionals.hide_dates_in_past) {
            bookingQuestion.hide_dates_in_past = moment().format('YYYY-MM-DD');

            // past date
            if (bookingQuestion.hide_dates_in_past) {
              let validators = [];
              if (bookingQuestion.required) {
                validators.push(Validators.required);
              }
              validators.push(this.pastDateValidator);
              control.setValidators(validators);
              control.updateValueAndValidity();
              this.companyQuestionsForm.updateValueAndValidity();
            }
          }
        }

        if (this.config["auto_select_service"]) {
          if (bookingQuestion.conditionals.hasOwnProperty('service_set')) {
            this.servicesList.forEach((service: any) => {
              if (`${service.id}` == bookingQuestion.conditionals.service_set) {
                this.selectService(service);
                console.log(service);
              }
            });
          }
        }

        let conditionals = bookingQuestion.conditionals;
        let show = conditionals.show;
        let hide = conditionals.hide;
        let admin_show = conditionals.admin_show;
        let admin_only = conditionals.admin_only;
        let custom = conditionals.custom;

        // if the booking is only for the admin journey
        if (admin_only && this.datastoreService.adminJourney) {
          show = admin_show;
          admin_only = false;
        }

        if (Object.keys(show).length === 0 && Object.keys(hide).length === 0 && !conditionals.admin_only) {
          // no hide or show conditional values, just show the question by default
          bookingQuestion.visible = true;
        }

        // show condition loop
        for (const answerId in show) {
          if (answerId == 'hide') {
            return; // this shouldnt happen only if the setup is wrong
          }
          if (answerId == 'custom') {
            // custom conditionals to go here
            let conditionalQuestion = this.companyQuestionsForm.get(`${Object.keys(show[answerId])[0]}`);
            if (conditionalQuestion && conditionalQuestion.value != null) {
              if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
                let condition: any = Object.values(show[answerId])[0];
                if (condition.includes('OR')) {
                  if (this.evaluateORCondition(condition, conditionalQuestion.value)) {
                    bookingQuestion.visible = true;
                  }
                } else {
                  if (this.evaluateCondition(condition, conditionalQuestion.value)) {
                    bookingQuestion.visible = true;
                  }
                }
              }
            }
          } else {
            // if this is an admin journey, and there is an admin show value
            if (this.datastoreService.adminJourney && admin_show) {
              // if we find a show in both
              if (admin_show[`${answerId}`] && show[`${answerId}`]) {
                // set the show to the admin version as it supersedes show
                show[`${answerId}`] = admin_show[`${answerId}`];
                bookingQuestion.admin_override = true;
              }
            }

            let conditionalQuestion = this.companyQuestionsForm.get(`${answerId}`);
            if (conditionalQuestion && conditionalQuestion.value != null) {
              if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
                if (show[answerId].trim() == "*") { // wild card
                  if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) { // if there is any answer
                    bookingQuestion.visible = true;
                  }
                } else {
                  if (`${conditionalQuestion.value}` == `${show[answerId]}`) {
                    bookingQuestion.visible = true;
                  }
                }
              }
            }
          }
        }

        // perform hide after show because we want it to take priority
        for (const answerId in hide) {
          if (answerId == 'show') {
            return; // this shouldnt happen only if the setup is wrong
          }
          if (answerId == 'custom') {
            let conditionalQuestion = this.companyQuestionsForm.get(`${Object.keys(hide[answerId])[0]}`);
            if (conditionalQuestion && conditionalQuestion.value != null) {
              if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
                let condition: any = Object.values(hide[answerId])[0];
                if (condition.includes('OR')) {
                  if (this.evaluateORCondition(condition, conditionalQuestion.value)) {
                    bookingQuestion.visible = true;
                  }
                } else {
                  if (this.evaluateCondition(condition, conditionalQuestion.value)) {
                    bookingQuestion.visible = true;
                  }
                }
              }
            }
          } else {
            let conditionalQuestion = this.companyQuestionsForm.get(`${answerId}`);
            if (conditionalQuestion && conditionalQuestion.value != null) {
              if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
                if (show[answerId] == "*") { // wild card
                  if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) { // if there is any answer
                    bookingQuestion.visible = true;
                  }
                } else {
                  if (`${conditionalQuestion.value}` == `${show[answerId]}`) {
                    bookingQuestion.visible = false;
                  }
                }
              }
            }
          }
        }

        // copy question schema
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('copy_data')) {
            bookingQuestion.copy_data_from = bookingQuestion.conditionals['copy_data'].from;
            bookingQuestion.copy_data_to = bookingQuestion.conditionals['copy_data'].to;

            if (bookingQuestion.answer) {
              bookingQuestion.copy_data_from.forEach((fromId, index) => {
                const toId = bookingQuestion.copy_data_to[index];
                const sourceControl = this.companyQuestionsForm.get(String(fromId));
                const targetControl = this.companyQuestionsForm.get(String(toId));
                if (sourceControl && targetControl) {
                  targetControl.setValue(sourceControl.value);
                } else {
                  console.warn(`Control not found for: ${fromId} or target: ${toId}`);
                }
              });
            }
          }
        }

        // set company from question
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('set_company')) {
            this.setCompanyFromQuestion = bookingQuestion.conditionals['set_company'];
          }
        } else {
          if (bookingQuestion.conditionals.hasOwnProperty('set_company')) {
            this.setCompanyFromQuestion = false
          }
        }

        // add hidden field
        if (bookingQuestion.conditionals.hasOwnProperty('hidden_field')) {
          bookingQuestion.hidden = true;
        }

        // add duration schema 
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('add_duration')) {
            this.datastoreService.extraDuration = (Number(this.datastoreService.extraDuration) + Number(bookingQuestion.conditionals.add_duration));
          }
        }

        // set sevice/resource question to var
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('service_set')) {
            this.datastoreService.setService = bookingQuestion.conditionals.service_set;
          }
          if (bookingQuestion.conditionals.hasOwnProperty('resource_set')) {
            this.datastoreService.setResource = bookingQuestion.conditionals.resource_set;
            console.log(bookingQuestion);
            let selectedSuggestion = {
              resource_id: this.datastoreService.setResource
            }
            this.datastoreService.selectedSuggestion = selectedSuggestion;
          }
        }

        // set client data on booking details page
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('booker_first_name')) {
            this.datastoreService.booker_first_name = bookingQuestion.id;
          }
          if (bookingQuestion.conditionals.hasOwnProperty('booker_last_name')) {
            this.datastoreService.booker_last_name = bookingQuestion.id;
          }
          if (bookingQuestion.conditionals.hasOwnProperty('booker_email')) {
            this.datastoreService.booker_email = bookingQuestion.id;
          }
          if (bookingQuestion.conditionals.hasOwnProperty('booker_phone')) {
            this.datastoreService.booker_phone = bookingQuestion.id;
          }
        }

        if (bookingQuestion.conditionals.hasOwnProperty('continuebutton')) {
          // showContinueButton
          let conditionalQuestion = this.companyQuestionsForm.get(`${Object.keys(bookingQuestion.conditionals.continuebutton)[0]}`);
          if (conditionalQuestion && conditionalQuestion.value != null) {
            if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
              if (Object.values(bookingQuestion.conditionals.continuebutton)[0][0] == "*") { // wildcard
                if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
                  if (this.config["auto_select_service"]) {
                    this.showContinueButton = true;
                  } else {
                    // filter services
                    if (this.datastoreService.setService) {
                      this.filteredServiceList = this.servicesList.filter(service => `${service.id}` == `${this.datastoreService.setService}`);
                    } else {
                      this.filteredServiceList = this.servicesList;
                    }
                    this.showServices = true;
                  }
                }
              } else {
                if (conditionalQuestion.value == Object.values(bookingQuestion.conditionals.continuebutton)[0][0]) {
                  if (this.config["auto_select_service"]) {
                    this.showContinueButton = true;
                  } else {
                    // filter services
                    if (this.datastoreService.setService) {
                      this.filteredServiceList = this.servicesList.filter(service => `${service.id}` == `${this.datastoreService.setService}`);
                    } else {
                      this.filteredServiceList = this.servicesList;
                    }
                    this.showServices = true;
                  }
                }
              }
            }
          }
        }

        if (!this.datastoreService.adminJourney && admin_only) {
          bookingQuestion.visible = false;
        }

        if (!bookingQuestion.visible) {
          let conditionalQuestion = this.companyQuestionsForm.get(`${bookingQuestion.id}`);
          conditionalQuestion.reset();
          conditionalQuestion.clearValidators();
          conditionalQuestion.updateValueAndValidity();
        }

        if (this.showServices) { // prechecks for continue button
          if (bookingQuestion.aws_lookup) { // any lookups

            let conditionalQuestion = this.companyQuestionsForm.get(`${bookingQuestion.lookup_field}`);
            if (bookingQuestion.lookedup_value == conditionalQuestion.value) {
              return; // we already looked this answer up once, dont bother again for former schema changes
            }
            let response = await this.apiService.lookupReference(bookingQuestion.aws_table, bookingQuestion.field, conditionalQuestion.value);
            // 1 = found
            // 2 = no data
            // 3 = error
            bookingQuestion.lookedup_value = conditionalQuestion.value;
            if (response['custom_response_code'] == 1) {
              this.datastoreService.reference = response['reference'];
              this.lookupError = false;
              return "checked";
            } else {
              this.lookupError = true;
              return "checked";
            }
          }
        }
      } else {
        bookingQuestion.visible = true;
      }
    });
  }

  isValidDate(dateString: string): boolean {
    // Attempt to create a Date object from the dateString
    const date: Date = new Date(dateString);

    // Check if the created Date object is valid and its string representation matches the input
    return date instanceof Date && !isNaN(date.getTime()) && date.toISOString().slice(0, 10) === dateString;
  }

  evaluateORCondition(condition, answer) {
    const parts = condition.split(' OR ');

    let evaluation = [];
    // Evaluate each part of the condition
    for (const part of parts) {
      if (part == answer) {
        evaluation.push(true);
      } else {
        evaluation.push(false);
      }
    }

    let evalArray = evaluation.some(element => element === true);
    // If evaluation has a true, one of the values is correct so it will return true
    return evalArray;
  }

  // Function to evaluate custom condition
  evaluateCondition(condition, answer) {

    // Split the condition into individual parts
    const parts = condition.split(' and ');

    // Evaluate each part of the condition
    for (const part of parts) {
      // Split the part into operator and threshold
      let [operator, thresholdStr] = part.split(' ');
      const threshold = parseFloat(thresholdStr);

      // decode html entity
      operator = he.decode(operator);

      if (this.isValidDate(answer)) {
        answer = (moment(answer).diff(moment(), 'days') + 1);
      }

      // Perform the comparison based on the operator
      switch (operator) {
        case '<':
          if (!(parseFloat(answer) < threshold)) {
            return false; // If any part is false, the entire condition is false
          }
          break;
        case '<=':
          if (!(parseFloat(answer) <= threshold)) {
            return false;
          }
          break;
        case '>':
          if (!(parseFloat(answer) > threshold)) {
            return false;
          }
          break;
        case '>=':
          if (!(parseFloat(answer) >= threshold)) {
            return false;
          }
          break;
        case '=':
          if (!(parseFloat(answer) === threshold)) {
            return false;
          }
          break;
        default:
          return false;
      }
    }

    // If all parts pass, return true
    return true;
  }

  addHyperlinks(question) {
    let linkPattern = /#(.*?)#/g;
    if (linkPattern.test(question.conditionals.component_text)) {
      // replace the #link# with a hyperlink
      question.conditionals.component_text = question.conditionals.component_text.replace(linkPattern, function (match, p1) {
        return `<a href="${question.conditionals.hyperlink}" target="_blank">` + p1 + '</a>';
      });
    }
    return question.conditionals.component_text;
  }

  setAddress(event, question) {
    // set the address value on the form
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = selectElement.value; // This now gives you `option.id`
    console.log('Selected Value:', selectedValue);
    this.companyQuestionsForm.controls[question.reference].setValue(selectedValue);
    console.log(this.companyQuestionsForm);
  }

  getAddress(question) {
    this.showingAddresses = true;
    // Custom error handling for postcode
    let postcode: String = this.companyQuestionsForm.controls["postcode_" + question.reference].value.replace(/\s/g, '');
    this.apiService.get(postcode).subscribe((res) => {
      var object: any = res;
      if (object.results) {

        var addresses = object.results;
        question.addresses = []
        if (addresses.length > 1) {
          // If it matches up, push the addresses
          addresses.forEach((item) => {
            if (item.DPA) {
              question.addresses.push({ address: item.DPA });
            } else {
              question.addresses.push({ address: item.LPI });
            }
          });
        }
      }
      this.spinner.hide();
    }, err => {
      console.log(err)
      this.spinner.hide();
    });
  }

  // Go back to the booking details page
  routerGoBack() {
    // If location is before services then redirect back to locations else redirect back to departments
    this.router.navigate(["/departments"]);
  }

  restartJourney() {
    this.router.navigate(["/departments"]);
  }

  async ngOnInit() {
    this.adminOnlyJourney = this.datastoreService.adminJourney;
    this.serviceUnavailable = this.datastoreService.serviceUnavailable;
    console.log(this.datastoreService.serviceUnavailable);
    try {
      this.spinner.show();
      const _config: any = await this.apiService.getConfig(AppConfig.settings.core.company_id);
      this.datastoreService.config = _config;
      const appConfig: any = await this.configService.getConfig();
      appConfig.first_page_questions_to_ignore = _config.journey_config.ceremonies.first_page_questions_to_ignore;
      this.configService.setConfig(appConfig);
      this.spinner.hide();
      this.loadedConfig = true;
      this.config = await this.configService.getConfig();
      this.companyId = _config.company;
      this.suggestions = [];

      // check config for kill switch
      if (!this.datastoreService.adminJourney) {
        if (_config.journey_config.hasOwnProperty('killswitch')) {
          this.serviceUnavailable = _config.journey_config.killswitch;
        }
      }

    }
    catch (err) {
      console.log(err)
      this.spinner.hide();
    }
    this.datastoreService.bookingForm = null;
    this.datastoreService.companyQuestionsForm = null;
    this.datastoreService.selectedDate = null;
    this.datastoreService.selectedSlot = null;
    this.availabilityService.setSelectedSlot(null);
    this.scrollToTop();
    this.spinner.show();

    // Use this.departmentService.getLocation() if the services are set on the children departments
    // Use this.departmentService.get() if the services are set on the parent department
    this.departmentService.get().then(
      (selectedDepartment) => {
        if (selectedDepartment === undefined) {
          this.restartJourney();
        } else {
          this.selectedDepartment = selectedDepartment;

          // Get the configurable data
          if (this.selectedDepartment.hasOwnProperty("extra")) {
            // Set the extra text on the page to the text taken from the business question
            this.selectedDepartment.extra.hasOwnProperty("services_page_text")
              ? (this.servicePageText = this.selectedDepartment.extra.services_page_text)
              : null;
            this.selectedDepartment.extra.hasOwnProperty("service_guidance_text")
              ? (this.guidanceText = this.selectedDepartment.extra.service_guidance_text)
              : null;
          }

          // Get the available services on the selected department
          this.servicesService
            .getServices(selectedDepartment)
            .then((services) => {
              this.memberService.getMember().then(
                (member) => {
                  this.servicesList = services;
                  services.forEach((service, index) => {
                    // service.$getImages().then((image) => {
                    //   service.image = image[0];
                    //   this.cdref.detectChanges();
                    // });
                  });
                  this.spinner.hide();
                },
                (err) => {
                  this.alertService.error(
                    this.translateService.instant("COMMON.GENERAL_ERR")
                  );
                  this.spinner.hide();
                }
              );
            });
        }
      },
      (err) => {
        this.alertService.error(
          this.translateService.instant("COMMON.GENERAL_ERR")
        );
        this.spinner.hide();
      }
    );
  }

  validateQuestions(event, question) {

    // Extract the day, month, and year values from the inputs
    const dayInput = (document.getElementById(`${question.id}_d`) as HTMLInputElement)?.value;
    const monthInput = (document.getElementById(`${question.id}_m`) as HTMLInputElement)?.value;
    const yearInput = (document.getElementById(`${question.id}_y`) as HTMLInputElement)?.value;

    // Combine them into a single date string
    const day = dayInput?.padStart(2, '0'); // Ensure day is two digits
    const month = monthInput?.padStart(2, '0'); // Ensure month is two digits
    const year = yearInput; // Year doesn't need padding

    // Validate that the inputs are valid and combine into a date
    if (day && month && year) {
      this.companyQuestionsForm.controls[question.reference].markAsTouched();
      this.companyQuestionsForm.controls[question.reference].markAsDirty();
      const combinedDate = `${year}-${month}-${day}`; // Format: YYYY-MM-DD
      if (this.isValidDateQuestion(combinedDate)) {
        console.log(combinedDate);
        this.companyQuestionsForm.controls[question.reference].setValue(combinedDate);
        console.log(this.companyQuestionsForm);
      } else {
        console.error('Invalid date entered:', combinedDate);
        // question.selectedDate = null; // Clear selectedDate if invalid
      }
    } else {
      question.selectedDate = null; // Clear selectedDate if not all fields are filled
    }


    console.log("change", event, event.source)
    if (question.id === 34299) {
      if (event.target.selectedIndex > 0) {
        this.answeredQuestions[0] = true;
      }
      else {
        this.answeredQuestions[0] = false;
      }
    }
    if (question.id === 276) {
      if (event.target.selectedIndex > 0) {
        this.answeredQuestions[1] = true;
      }
      else {
        this.answeredQuestions[1] = false;
      }
    }
    if (question.id === 278) {
      if (event.source._checked === true) {
        this.answeredQuestions[2] = true;
        this.ageType = event.source._value;
      }
      else {
        this.answeredQuestions[2] = false;
      }
    }
    // this.calculateVisibility();
    this.onQuestionChange();
  }

  isValidDateQuestion(dateString: string): boolean {
    const date = new Date(dateString);
    return !isNaN(date.getTime()); // Check if the date is valid
  }

  calculateVisibility() {
    // let trueCount = 0;
    // for (const item of this.answeredQuestions) {
    //   if (item) {
    //     trueCount++;
    //   }
    // }
    // if (trueCount >= 1) { // count of questions
    //   this.showServices = true;
    // }
    // else {
    //   this.showServices = false;
    // }
  }

  updateRadio(form, question, answer) {
    console.log(form, question, answer)
    form.controls[question].reset();
    form.controls[question].clearValidators();
    form.controls[question].updateValueAndValidity();
    this.onQuestionChange()
    this.searchText = '';
    this.suggestions = [];
    // crappy fix for updating radios for https://bookinglab.atlassian.net/browse/EMS-739
    // need to find a better way when time allows
    form.controls[question].setValue(answer);
    this.onQuestionChange()
  }

  selectService(service: any = undefined) {
    this.spinner.show();
    let selectedService
    if (service) {
      selectedService = service;
    } else {
      selectedService = this.filteredServiceList[0];
    }

    console.log(service);
    this.selectedService = selectedService;
    this.servicesService.selectedService = selectedService;
    // if (this.companyQuestionsForm.invalid) {
    //   this.scrollToTop();
    //   this.spinner.hide();
    //   this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
    //   return;
    // }

    this.datastoreService.companyQuestionsForm = this.companyQuestionsForm;

    if (!(this.config["auto_select_service"])) {
      this.continue();
    }
  }

  continue() {
    this.spinner.show();
    if (this.selectedService) {
      this.servicesService.set(this.selectedService);
      // backup the service so that if we switch to the alt company we have a way to swtich back
      this.datastoreService.selectedService = this.selectedService;
      this.datastoreService.startQuestions = this.companyQuestionsForm

      if (this.setCompanyFromQuestion) {
        // this.datastoreService
        this.setLocationAndResource(this.setCompanyFromQuestion);
      } else {
        if (!this.skipLocations) {
          this.router.navigate(["/locations"]);
        } else {
          this.setLocationAndResource(this.datastoreService.selectedSuggestion.company_id);
        }
      }

    } else {
      this.alertService.warn("Please select a service before proceeding");

      this.scrollToTop();
    }
  }

  setLocationAndResource(companyIdToSelect) {
    this.departmentService.get().then(async (selectedDepartment) => {
      this.locations = null;
      this.datastoreService.locations = null;
      this.selectedDepartment = selectedDepartment;

      // Get the children departments (locations) from the selected department
      await this.departmentService.getSelectedDepartmentChildren(this.selectedDepartment.id, this.servicesService.selectedService.id).then(async (locations) => {
        await this.departmentService.setLocationList(locations).then(async (filteredLocations) => {

          // await filteredLocations.forEach((tempLocation: any) => {
          //   tempLocation.$getAddress().then((res) => {
          //     tempLocation.addresses = res;
          //   });
          // });

          filteredLocations = filteredLocations.filter(selectedLocation => Number(selectedLocation.id) == Number(companyIdToSelect));

          // Filter locations on the service & then display them here
          this.locations = filteredLocations;
          this.datastoreService.locations = filteredLocations;
          this.selectedLocation = this.locations[0];
          console.log(`Selected location ${this.selectedLocation.id} ${this.selectedLocation.name}`);
          this.continueSkip();
          this.spinner.hide();
        });
      }, err => {
        console.error(err);
        this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'))
        this.spinner.hide();
      });
    }, err => {
      this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'))
      this.spinner.hide();
    });
  }

  continueSkip() {
    // Use this.departmentService.getLocation() if the services are set on the children departments
    // Use this.departmentService.get() if the services are set on the parent department
    this.departmentService.get().then(location => {
      if (this.selectedLocation) {
        if (location && location !== this.selectedLocation) {
          this.datastoreService.selectedDate = null;
          this.availabilityService.setSelectedSlot(null);
        }
        this.departmentService.setLocation(this.selectedLocation);
        // If we picked an alt company as our cmpany, change up the service and parent company
        if (this.selectedLocation.membership_id.toString() === this.core.alt_company_id) {
          this.departmentService.getAltParentDepartment().then(altDepartment => {
            this.servicesService
              .getServices(altDepartment)
              .then((altServices) => {
                // const altService = altServices.filter(x => x.id.toString() === this.core.alt_service_id)[0]
                const altService = altServices.filter(x => x.name === this.datastoreService.selectedService.name)[0]

                if (altService) {
                  altDepartment.extra = location.extra;
                  this.datastoreService.selectedDepartment = this.selectedDepartment;

                  this.servicesService.set(altService);
                  this.departmentService.set(altDepartment)
                  console.log("altDepartment")
                  this.router.navigate(['/calendar']);
                } else {
                  this.alertService.warn("Error loading alt department data");

                  this.scrollToTop();
                }
              });
          });

        } else {
          this.router.navigate(['/calendar']);
        }
      } else {
        this.alertService.warn("Please select a location before proceeding");

        this.scrollToTop();
      }
    });
  }

  // scroll to the top of the page
  scrollToTop() {
    const scrollToOptions = { top: 0, left: 0, behavior: 'instant' };
    window.scrollTo(scrollToOptions as unknown as ScrollToOptions);
  }

  async getCompanyQuestions() {
    this.questionsService.getCompanyQuestions().subscribe((res: any) => {
      // Questions = all questions on the company
      const questions = res.questions;
      this.datastoreService.companyQuestions = questions;
      this.addQuestionsToForm(questions)
    });
  }

  async onSearch(event: Event, question: any): Promise<void> {
    question.selected_resource = undefined;
    this.skipLocations = false;
    question.searching = true;
    question.noResults = false;
    try {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(async () => {
        this.suggestions = [];
        const query = (event.target as HTMLInputElement).value;
        this.searchText = query.trim();
        if (this.searchText) {
          this.suggestions = await this.apiService.searchVenue(this.companyId, this.searchText);
          question.searching = false;
          if (question.filter_by) {
            // go get the question from the form from the filter_by id
            const filterControl = this.companyQuestionsForm.get(`${question.filter_by}`);
            this.suggestions = this.suggestions.filter(suggestion => suggestion.venue_type.toLowerCase().trim() == filterControl.value.toLowerCase().trim());
            console.log(`Filtering by: ${filterControl.value}`);
            console.log(`Filtered Suggestions:`);
            console.log(this.suggestions);
          }
          if (question.filter_by_name) {
            // go get the question from the form from the filter_by_name id
            const filterValue = question.filter_by_name
            this.suggestions = this.suggestions.filter(suggestion => suggestion.venue_type.toLowerCase().trim() == filterValue.toLowerCase().trim());

            console.log(`Filtering by: ${filterValue}`);
            console.log(`Filtered Suggestions:`);
            console.log(this.suggestions);
          }
          if (this.suggestions.length == 0) {
            question.noResults = true;
          }
        } else {
          question.searching = false;
          this.suggestions = [];
        }
      }, 500);
    } catch (error) {
      console.log(error);
    }
  }

  clearSearch(question: any): void {
    // reset
    this.searchText = '';
    this.suggestions = [];
    question.selected_resource = null;
    question.searching = false;
    question.noResults = false;
    // clear the control value 
    this.companyQuestionsForm.controls[question.id].setValue('');
    this.onQuestionChange();
  }

  selectSuggestion(suggestion: string, question: any): void {
    this.suggestions = [];
    this.searchText = suggestion['pretty_name'] ? suggestion['pretty_name'] : suggestion['venue_name'];
    question.selected_resource = suggestion;
    this.datastoreService.selectedSuggestion = suggestion;
    if (this.autoSetLocation) {
      this.skipLocations = true;
    }
    this.companyQuestionsForm.controls[question.id].setValue(suggestion['pretty_name']);
    this.companyQuestionsForm.controls[question.id].updateValueAndValidity();
    this.onQuestionChange();
  }

  addQuestionsToForm(questions) {
    this.companyQuestionsForm = this.formBuilder.group({});
    for (let index = 0; index < questions.length; index++) {
      const question = questions[index];
      question.visible = false;
      question.reference = question.id;
      if (!question.admin_only) {
        if (!question.settings.hasOwnProperty("conditional_question")) {
          question.visible = false; // default hidden all
        }

        const questionControl = question.id;

        if (!question["help_text"]) { // question without any config
          question.conditionals = {
            page: this.router.url, // show on current page
          };
        } else {
          question.conditionals = JSON.parse(question["help_text"]);
        }

        if (question.conditionals.page == this.router.url.replace("/", "")) {

          this.companyQuestions.push(question);

          let validators = [];

          // required validators
          if (question.required) {
            validators.push(Validators.required);
          }
          if (question.conditionals['address_lookup']) {
            this.companyQuestionsForm.addControl("postcode_" + questionControl, new UntypedFormControl((''), validators));
          }
          if (question.detail_type == 'check' || question.detail_type == 'check-price') {
            this.companyQuestionsForm.addControl(questionControl, new UntypedFormControl(false, validators));
          } else {
            this.companyQuestionsForm.addControl(questionControl, new UntypedFormControl((''), validators));
          }
        } else {
          // console.log(`skipped ${question.id}`); // debugging remove later
        }
      }
    }
    this.onQuestionChange();
  }
}
